export const RFMonogram = ({ className = "" }) => {
  return (
    <span
      aria-label="RF"
      role="img"
      className={`inline-flex align-middle ${className}`}
    >
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-full"
      >
        <defs>
          <linearGradient id="rf-gold" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#e8c67a" />
            <stop offset="50%" stopColor="#c9a55c" />
            <stop offset="100%" stopColor="#8a6b2c" />
          </linearGradient>
        </defs>
        <circle
          cx="50"
          cy="50"
          r="46"
          fill="none"
          stroke="url(#rf-gold)"
          strokeWidth="1.2"
          opacity="0.85"
        />
        <text
          x="30"
          y="66"
          textAnchor="middle"
          fontFamily='"Playfair Display", "Bodoni Moda", Georgia, serif'
          fontSize="60"
          fontWeight="500"
          fill="url(#rf-gold)"
          opacity="0.95"
        >
          R
        </text>
        <text
          x="66"
          y="76"
          textAnchor="middle"
          fontFamily='"Playfair Display", "Bodoni Moda", Georgia, serif'
          fontSize="60"
          fontWeight="500"
          fill="url(#rf-gold)"
          opacity="0.95"
        >
          F
        </text>
      </svg>
    </span>
  );
};
